// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df9cc059","732":"3626f93f","977":"803231b8"}[chunkId] + ".chunk.js";
};